import * as INDEX_IMG from "../assets/img/projects/previews/index";
import * as STACK_IMG from "../assets/img/skills/";

export const projectsList = [
  {
    links: {
      GitHub:
        "https://github.com/gemmas95/Other_projects/tree/master/github-project-redux",
      "Watch Video":
        "https://www.linkedin.com/posts/gemma-sanz-rabadan_redux-react-activity-6729693684721315841-jbMS",
    },
    imgAltText: "Contributors list",
    imgSrc: INDEX_IMG.I_CONTRIBUTORS,
    title: "Contributors list",
    tech_stack: [
      STACK_IMG.L_REACT,
      STACK_IMG.L_REDUX,
      STACK_IMG.L_CSS3,
      STACK_IMG.L_BOOTSTRAP,
      STACK_IMG.L_JEST,
    ],
    description:
      "Frontend responsive app with redux that call the GitHub api and return a list of a contributors of a given repository.",
  },
  {
    links: {
      GitHub: "https://github.com/gemmas95/OnSport",
      Testing:
        "https://www.linkedin.com/posts/gemma-sanz-rabadan_cleancode-sonarqube-testing-activity-6719261190524170240-jbSw",
      "Watch Video":
        "https://www.linkedin.com/posts/gemma-sanz-rabadan_fullstack-react-responsive-activity-6716035714821193728-1OAS",
    },
    imgAltText: "OnSport",
    imgSrc: INDEX_IMG.I_ONSPORT,
    title: "OnSport",
    tech_stack: [
      STACK_IMG.L_REACT,
      STACK_IMG.L_FLUX,
      STACK_IMG.L_SASS,
      STACK_IMG.L_MATERIALUI,
      STACK_IMG.L_NODE_JS,
      STACK_IMG.L_EXPRESS,
      STACK_IMG.L_MONGODB,
      STACK_IMG.L_JEST,
      STACK_IMG.L_MOCHA,
      STACK_IMG.L_CHAI,
      STACK_IMG.L_SINON,
    ],
    description:
      "🌟 FullStack sports web application, where users can subscribe to centers' acivities",
  },
  {
    links: {
      GitHub:
        "https://github.com/gemmas95/skylab-bootcamp-202008/tree/master/organic-market/group03",
    },
    imgAltText: "Organic Market",
    imgSrc: INDEX_IMG.I_ORGANIC_MARKET,
    title: "Organic Market Project",
    tech_stack: [STACK_IMG.L_NODE_JS, STACK_IMG.L_EXPRESS, STACK_IMG.L_MONGODB],
    description:
      "Server Side web application using EJS where a user can buy organic products",
  },
  {
    links: {
      GitHub: "https://github.com/gemmas95/DragonBall",
      "Watch Video":
        "https://www.linkedin.com/feed/update/urn:li:activity:6699423455185514497/",
      "Live Demo": "https://dragon-ball-project-ggj.web.app/",
    },
    imgAltText: "Dragon Ball",
    imgSrc: INDEX_IMG.I_DRAGON_BALL,
    title: "Dragon Ball Project",
    tech_stack: [
      STACK_IMG.L_REACT,
      STACK_IMG.L_FLUX,
      STACK_IMG.L_BOOTSTRAP,
      STACK_IMG.L_SASS,
    ],
    description:
      "Frontend web application for the fans of Dragon Ball with an interactive battle game",
  },
  {
    links: {
      GitHub:
        "https://github.com/gemmas95/skylab-bootcamp-202008/tree/master/Gemma-Sanz/Week%202/Challenge-game-of-life",
    },
    imgAltText: "Convay Game Of Life",
    imgSrc: INDEX_IMG.I_GAME_OF_LIFE,
    title: "Convay Game Of Life",
    tech_stack: [STACK_IMG.L_JAVASCRIPT, STACK_IMG.L_HTML5, STACK_IMG.L_CSS3],
    description: "Convay Game of Life application",
  },
  {
    links: {
      GitHub:
        "https://github.com/gemmas95/skylab-bootcamp-202008/tree/master/Gemma-Sanz/Week%201/5.%20Day/Challenge_Weekend-Rakuten",
      "Watch Video":
        "https://www.linkedin.com/posts/gemma-sanz-rabadan_skylabcodersacademy-frontend-code-activity-6693174240834797568-4qWN",
    },
    imgAltText: "Rakuten",
    imgSrc: INDEX_IMG.I_RAKUTEN,
    title: "Rakuten",
    tech_stack: [STACK_IMG.L_HTML5, STACK_IMG.L_CSS3],
    description: "Layout of Rakuten dashboard web page",
  },
  /*   {
    links: {
      GitHub:
        "https://github.com/gemmas95/skylab-bootcamp-202008/tree/master/Gemma-Sanz/Precourse%20projects/calculator-html",
      "Watch Video":
        "https://www.linkedin.com/posts/gemma-sanz-rabadan_skylab-calculatorhtml-webdeveloper-activity-6690991861462519808-eROg",
    },
    imgAltText: "Calculator",
    imgSrc: INDEX_IMG.I_CALCULATOR,
    title: "Calculator",
    tech_stack: [STACK_IMG.L_JAVASCRIPT, STACK_IMG.L_HTML5, STACK_IMG.L_CSS3],
    description: "Calculator application",
  }, */
];
